import { render, staticRenderFns } from "./DetailSchool.vue?vue&type=template&id=1170e19d"
import script from "../../services/school/detail-school.js?vue&type=script&lang=js&external"
export * from "../../services/school/detail-school.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/teacher/detail-teacher.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports